<template>
    <sub-menu id="wifi">
        <sub-menu-item to="/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social" icon="fa-wifi">
            <span v-tr>Guest & Social WiFi|WiFi public & social</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux" icon="fa-shopping-bag">
            <span v-tr>WiFi CRM for Malls & Retail|CRM WiFi pour Détaillants</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes" icon="fa-bus">
            <span v-tr>Transports & Bus WiFi|WiFi pour bus & transports</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi/technology|/wifi-public/technologie-et-compatibilite" icon="fa-router">
            <span v-tr>Cisco & Meraki Compatibility|Compatibilité Cisco & Meraki</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi/compliant-gdpr-law-25|/wifi-public/conformite-rgpd-et-loi-25" icon="fa-shield-check">
            <span v-tr>GDPR & Law 25 Compliant|Conformité RGPD et Loi 25</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi/services|/wifi-public/services" icon="fa-tools">
            <span v-tr>Our Services|Nos services</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi/clients|/wifi-public/marches-et-clients" icon="fa-users-crown">
            <span v-tr>Our Markets & Clients|Nos clients et marchés</span>
        </sub-menu-item>
    </sub-menu>
</template>

<script>

import SubMenuItem from "@/components/sub-menu-item.vue";
import SubMenu from "@/components/sub-menu.vue";
export default {
    name: `wifi-navigation`,
    components: {SubMenuItem, SubMenu}
}
</script>

<style lang="scss" scoped>
</style>
